module.exports = __webpack_public_path__ + "static/media/Aliane_Beaujolais-Villages_VV_Specs.cef36f4c.jpg";